var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.stats)?_c('CardContainer',{attrs:{"title":_vm.title}},[_c('template',{slot:"chart"},[_c('CChartLine',{attrs:{"datasets":_vm.chartData,"labels":_vm.chartLabel,"options":_vm.chartOption}})],1)],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }